import React from 'react'
import { Avatar, Space } from 'antd'
import { Select, Option } from './styles'
import BankSelectHook from './BankSelect.hook'

interface BankSelectProps {
  value?: string
  onChange?: (value: string) => void
  placeholder?: string
  disabled?: boolean
}

function BankSelect({ value, onChange, placeholder = 'เลือก', disabled }: BankSelectProps) {
  const { getBanks, isCreateOrEditMode } = BankSelectHook()

  const handleChange = (selectedValue: string) => {
    if (onChange) {
      onChange(selectedValue)
    }
  }

  return (
    <Select
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      optionLabelProp="label"
      listHeight={512}
      size="large"
      disabled={disabled !== undefined ? disabled : !isCreateOrEditMode}
      loading={getBanks.isLoading}
    >
      {getBanks.data?.map((bank) => (
        <Option
          key={bank.code}
          value={bank.id}
          label={
            <>
              <Space>
                <Avatar src={bank.iconUrl} />
              </Space>
              <Space style={{ paddingLeft: 10 }}>{bank.name}</Space>
            </>
          }
        >
          <Space size={0} align="start">
            <Space>
              <Avatar src={bank.iconUrl} size="large" />
              <div>
                <div>{bank.name}</div>
                <div style={{ fontSize: 12, color: '#888' }}>{bank.code}</div>
              </div>
            </Space>
          </Space>
        </Option>
      ))}
    </Select>
  )
}

export default BankSelect
